import { useState } from "react";
import AppLayout from "@amzn/awsui-components-react/polaris/app-layout";

import { ManageOrdersTable } from "../../components/ManageOrders";
import NavigationBreadcrumbs from "../../common/navigation/NavigationBreadcrumbs";
import SideNavigationMenu from "../../common/navigation/SideNavigationMenu";

import Paths from "../../common/paths/paths";
import { Flashbar } from "@amzn/awsui-components-react";
import { useFlashBarItems } from "../../common/UseFlashBarItems/useFlashBarItems";
import OrderDetailsSidePanel from "components/ManageOrders/OrderSidePanel";
import { useDetailsSidePanel, useManageOrdersTable } from "components/ManageOrders/useManageOrdersTable";

const breadcrumbs = {
    items: [
        { text: Paths.Admin.name, href: Paths.uploadLicense.url },
        { text: Paths.manageOrders.name, href: Paths.manageOrders.url },
    ],
};

const ManageOrdersPage = () => {
    const [navigationOpen, setNavigationOpen] = useState(false);
    const flashBarItemsHook = useFlashBarItems();
    const detailsSidePanelHook = useDetailsSidePanel();
    const useManageOrdersTableHook = useManageOrdersTable();

    const onDetailsSidePanelChange = (open: React.SetStateAction<boolean>) => {
        if (!open) {
            useManageOrdersTableHook.actions.refreshAttributes();
        }
    };

    return (
        <AppLayout
            content={
                <ManageOrdersTable
                    useFlashBarItemsActions={flashBarItemsHook.actions}
                    useDetailsSidePanel={detailsSidePanelHook}
                    useManageOrdersTableHook={useManageOrdersTableHook}
                />
            }
            breadcrumbs={<NavigationBreadcrumbs items={breadcrumbs.items} />}
            navigation={<SideNavigationMenu />}
            navigationOpen={navigationOpen}
            tools={<OrderDetailsSidePanel selectedOrder={detailsSidePanelHook.selectedOrder} />}
            toolsOpen={detailsSidePanelHook.isOpened}
            onToolsChange={(event: any) => onDetailsSidePanelChange(event.detail.open)}
            toolsHide={!detailsSidePanelHook.isOpened}
            notifications={<Flashbar items={flashBarItemsHook.flashBarItems} stackItems />}
            onNavigationChange={(event: any) => setNavigationOpen(event.detail.open)}
        />
    );
};

export default ManageOrdersPage;
